import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { useAuth } from '@/context/use-auth';
import { Outlet, useLocation } from 'react-router';

import { AppSidebar } from './sidebar';

export function Layout() {
	const { pathname } = useLocation();
	const { routes } = useAuth();

	return (
		<SidebarProvider defaultOpen={false}>
			<AppSidebar collapsible="offcanvas" />
			<div className="flex h-full w-full flex-col">
				<div className="w-full bg-menu p-4">
					<div className="mx-auto max-w-[90rem] text-white">
						{/* <SidebarTrigger /> */}
					</div>
				</div>
				<div className="w-full p-4">
					<main className="mx-auto max-w-[90rem]">
						{routes ? (
							routes.some((route) => pathname.startsWith(route)) ? (
								<Outlet />
							) : (
								<Unauthorized />
							)
						) : (
							<Loading />
						)}
					</main>
				</div>
			</div>
		</SidebarProvider>
	);
}

export const Unauthorized = () => {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="text-2xl font-bold">Unauthorized</div>
		</div>
	);
};

export const Loading = () => {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="text-2xl font-bold">Loading...</div>
		</div>
	);
};
